import { z } from "zod";
export const numberSchema = z.coerce
  .number({ invalid_type_error: "Must be a number" })
  .min(0.01, "Limit is required and must be greater than 0");